import { Routes, Route, useLocation } from 'react-router-dom'
import { ProtectedElement } from '@praxis/component-auth'
import { ErrorBoundary } from '@praxis/component-logging'
import { ToastProvider } from '@enterprise-ui/canvas-ui-react'
import { ErrorContent } from './ErrorContent'
import { Unauthorized } from './Unauthorized'
import { AuthLogin } from './AuthLogin'
import Search from '../search/'

export const MainRouter = (props) => {
  const location = useLocation()
  const { getUserProfile } = props
  return (
    <ErrorBoundary key={location.pathname} FallbackComponent={ErrorContent}>
      <ToastProvider location="top">
        <Routes>
          {getUserProfile?.roles?.length > 0 ? (
            <>
              <Route
                path="/"
                element={
                  <ProtectedElement>
                    <Search />
                  </ProtectedElement>
                }
                unauthorizedRoute={'/unauthorized'}
              />
            </>
          ) : (
            <Route path="/" element={<Unauthorized />} />
          )}
          <Route path="/auth/login" element={<AuthLogin />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          {/* <Route path="*" element={<PageNotFound />} /> */}
        </Routes>
      </ToastProvider>
    </ErrorBoundary>
  )
}
